import React, { useEffect, useState } from "react";
import Popup from "../../components/common/Popup";
import {
  DKLabel,
  DKInput,
  INPUT_VIEW_DIRECTION,
  INPUT_TYPE,
  DKButton,
  DKIcon,
  DKTooltipWrapper,
  showAlert,
  DKIcons,
  showLoader, removeLoader, showToast, TOAST_TYPE
} from "deskera-ui-library";
import DKInputDateTime from "../common/DKInputDateTime";
import * as moment from "moment";
import { FORMAT, FORM_ACTIONS, ATTENDANCE_TYPE } from "../../constants/Constant";
import ic_info_message from "../../assets/icons/ic_info_gray01.png";
import Utility from "../../utility/Utility";
import FileUpload from "../common/FileUpload";
import { getFileName } from "../configs/config";
import AttachmentService, { Entity } from "../../services/AttachmentService";
import { saveAs } from 'file-saver';
import ic_erro_info from "../../assets/icons/ic_info_error.svg";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import i18next from "i18next";
const EmployeeAttendancePopup = (props) => {

  const [punchTime, setPunchTime] = useState(props.data.type === ATTENDANCE_TYPE.CLOCK_IN ? 
    (props.data.clockIn ? new Date(props.data.clockIn) : new Date()) : 
    (props.data.clockOut ? new Date(props.data.clockOut) : new Date()));
  const [attendanceTime, setAttendanceTime] = useState(punchTime);
const [errorMsg,setErrorMsg]= useState(props.punchingError?.punchingLogError)
  useEffect(() => {
    setErrorMsg(props.punchingError?.punchingLogError)
  },[props])
  const [clocking, setClocking] = useState({
    clockIn: props.data.clockIn ? new Date(props.data.clockIn):new Date(),
    clockOut: props.data.clockOut ? new Date(props.data.clockOut): new Date()
  })
  const [clockingAttendanceTime, setClockingAttendanceTime] = useState(clocking);
  const [remark, setRemark] = useState(props.data?.remark ? props.data.remark : "")
  const [canValidate, setCanValidate] = useState(false)
  const [attachmentPopup, setAttachmentPopup] = useState({
    showPopup: false,
    fileList: []
  })
  const [formValues, setFormValues] = useState({
    duration: "fullDay",
    attachments: props.data.attachments
  });
  const addAttendance = () => {
    if(Utility.isEmpty(remark.trim()) || (remark && remark.length >250)) {
      setCanValidate(true)
      return
    }
    if(isInvalidClockout() || isInvalidAddClockout()) {
      return;
    }
    const dataParam = {
      attachments: formValues.attachments
    }
    if(props.data.isEdit && !props.data.isFromPunchlog) {
      props.editAttendance({
        clockIn:moment(clockingAttendanceTime.clockIn).format(FORMAT.HHMM),
        clockOut: moment(clockingAttendanceTime.clockOut).format(FORMAT.HHMM)
      }, remark,dataParam);
    } else if(props.data.isFromPunchlog) {
      props.editPunchLogAttendance(moment(attendanceTime).format(FORMAT.HHMM), remark,dataParam);
    } else {
      props.addAttendance(moment(attendanceTime).format(FORMAT.HHMM), remark,dataParam);
    }
    
  };
  const getTooltip=(obj)=> {
    return (
        <div class="custom-tooltip position-relative width-auto ">
            <DKIcon
                src={ic_info_message}
                className="ml-s ic-s ml-r  cursor-hand "
                style={{ opacity: 0.4 }}
            />
            <span class={`custom-tooltiptext dk-input-holder border-radius-m 
                                shadow-m bg-white text-dark-gray border-m 
                                position-fixed p-m border-box z-index-6 ${obj.tooltipClass}`}>
                <DKLabel text={obj.tooltipText}/>
            </span>
        </div>
    )
}
  const isInvalidAddClockout = () => {
    if (props.data.type == 'CLOCK_OUT' && !(props.data.isEdit && !props.data.isFromPunchlog)) {
      let inTime = clocking.clockIn;
      let outTime = attendanceTime;
      if(props.data.isFromPunchlog && props.data?.parentRowData?.data?.clockIn) {
        inTime = props.data?.parentRowData?.data?.clockIn
      }
      const beginningTime = moment(moment(inTime).format(FORMAT.HHMM_A),FORMAT.HHMM_A);
      const endTime = moment(moment(outTime).format(FORMAT.HHMM_A),FORMAT.HHMM_A);
      const returnValue = !(beginningTime.isSameOrBefore(endTime))
      
      return returnValue;
    } else {
      return false
    }
  }
const isInvalidClockout=()=>{
  const beginningTime = moment(clocking.clockIn, FORMAT.HHMM_A);
  const endTime = moment(clocking.clockOut, FORMAT.HHMM_A);
  const returnValue = !(beginningTime.isBefore(endTime) || beginningTime.isSame(endTime))
  return returnValue;
}
const showUploadPopup = () => {
  return (
      <FileUpload
          isMultiSelect={false}
          onSave={(files) => {
              uploadDocument(files);
          }}
          onClose={() => {
              resetUploadConfig();
          }}
      />
  );
}
const uploadDocument = (files) => {
  if (files && files[0]) {
      showLoader("Uploading files... Please wait");
      AttachmentService.getUploadFileURL(
          files[files.length - 1].fileContent,
          Entity.PEOPLE_DOCUMENT
      ).then(
          (response) => {
              if (response?.relativePath) {
                  formValues['attachments'] = [response.relativePath];
                  setFormValues({
                      ...formValues
                  })
                  setAttachmentPopup({
                      showPopup: false
                  })
              }
              showToast("The document is uploaded successfully.", TOAST_TYPE.SUCCESS);
          },
          (error) => {
            if(error?.status === 500 && error?.message?.includes("CONTENT_TYPE_NOT_ALLOWED")) {
              showAlert(i18next.t('FAIL_TO_UPLOAD'), i18next.t('FILE_FORMAT_TYPE_ERROR_MSG'));
              removeLoader();
            } else {
              showToast(i18next.t('SOMETHING_WENT_WRONG'), TOAST_TYPE.FAILURE);
            }
          }
      ).finally(() => {
          removeLoader();
      });
  }
}
const resetUploadConfig = () => {
  setAttachmentPopup({
      showPopup: false
  })
}
const downloadDocument = (path) => {
  showLoader("Downloading document... Please wait");
  AttachmentService.getPresignedURL(path).then(
      (response) => {
          AttachmentService.downloadFile(response).then(
              (response) => {
                  removeLoader();
                  saveAs(response, getFileName(path));
              },
              (error) => {
                  removeLoader();
              }
          );
      },
      (error) => {
          removeLoader();
          showToast("Something went wrong", TOAST_TYPE.FAILURE);
      }
  );
}
const deleteAttachment = (index) => {
  formValues['attachments'].splice(index, 1);
  setFormValues({
      ...formValues
  })
}

const attachmentField = (c) => {
  return (
      <div className={`column m-v-l padding-bottom-mobile ${c.columnCode}`}>
          <div className="row row-responsive justify-content-start position-relative align-items-start">
              <div className="mr-l">
                  <div className="row-auto-width mb-xs dkinput-header-section mt-r">
                      <DKLabel className="" text={`${c.name}${c.required ? ` *` : ''}`} />
                      {(canValidate && Utility.isEmpty(formValues?.attachments) && c.required) && (
                          <DKTooltipWrapper
                              content={c.tooltiptext}
                              tooltipClassName="warning-tooltip-prop warning-tooltip-prop "
                          >
                              <DKIcon
                                  src={ic_erro_info}
                                  className="ml-s ic-s ml-r mt-xs cursor-hand "

                              />
                          </DKTooltipWrapper>
                      )}
                  </div>
              </div>

              <div className="row-auto-width dkinput-header-section ">
                  <div className="row" style={{ width: "auto" }}>
                      <DKButton className='p-s' icon={DKIcons.ic_attachment} onClick={() => {
                          setAttachmentPopup({
                              showPopup: true
                          })
                      }} />
                  </div>

              </div>
              {formValues?.attachments && <div className="">
                  {
                      formValues?.attachments.map((file, index) => {
                          return (
                              <div className="row mb-r">
                                  <DKButton icon={DKIcons.ic_download} className="bg-gray1 border-m" onClick={() => downloadDocument(file)} title={<DKLabel style={{ maxWidth: 135, minWidth: 135 }} className="ellipsis " text={getFileName(file)} />} />
                                  <DKIcon className="ic-s ml-s" src={DKIcons.ic_delete} onClick={() => deleteAttachment(index)} />
                              </div>
                          )
                      })
                  }
              </div>}
          </div>
      </div>
  )
}

  return (
    <>
    <Popup popupClass={props.popupClass}>
      <div className="row">
        <DKLabel text={(props.data.action === FORM_ACTIONS.ADD ? "Add" : "Edit") + " Attendance"} className="fs-xl fw-m row" />
        <div className="row justify-content-end">
          <DKButton
            className="bg-gray1 border-m mr-r"
            title={"Close"}
            onClick={() => props.onClose()}
          />
          <DKButton
            className={`bg-app border-m text-white ${props.enableSave? "bg-app":"bg-gray cursor-auto"}`}
            title={props.data.action === FORM_ACTIONS.ADD ? "Add" : "Edit"}
            disabled={!props.enableSave}
            onClick={addAttendance}
          />
        </div>
      </div>
      <div className="parent-width mt-xxl">
        <DKInput
          title={"Name"}
          className="mt-r"
          value={props.data.employeeName}
          type={INPUT_TYPE.TEXT}
          canValidate={false}
          direction={INPUT_VIEW_DIRECTION.HORIZONTAL}
          readOnly={true}
        />
        <DKInput
          title={"Date"}
          className="mt-r"
          value={props.data.date}
          type={INPUT_TYPE.TEXT}
          canValidate={false}
          direction={INPUT_VIEW_DIRECTION.HORIZONTAL}
          readOnly={true}
        />
        {(!props.data.isEdit || props.data.isFromPunchlog) &&<><DKInput
          title={"Type"}
          className="mt-r"
          value={props.data.type}
          type={INPUT_TYPE.TEXT}
          canValidate={false}
          direction={INPUT_VIEW_DIRECTION.HORIZONTAL}
          readOnly={true}
        />
        <div className="row justify-content-between">
          {!props.data.isFromPunchlog &&<DKLabel text="Select time*" className="" />}

          {props.data.isFromPunchlog &&<div className="d-flex">
            <DKLabel text="Select time*" className="" />
            {getTooltip(
              {
                tooltipText: (props.data.type =="CLOCK_OUT" ? "The last Out would be updated to last punch log entry": "The first clockIn would be updated to earliest punch log entry."),
                tooltipClass: "warning-tooltip-prop",
              }
            )}
          </div>}

          <div style={{ width: "54%" }}>
            <DKInputDateTime
              title={`Select Time`}
              hideCalendar={true}
              className={`parent-width m-v-s ${isInvalidAddClockout() ? "border-red border-radius-s":""}`}
              hideLabel={true}
              selectedDate={moment(punchTime, FORMAT.HHMM_A).format()}
              onSave={(date) => {
                if(props.data.action === FORM_ACTIONS.ADD && props.data.type ==="CLOCK_OUT") {
                  setClockingAttendanceTime({
                    ...clockingAttendanceTime,
                    clockOut: date
                  })
                  setClocking({
                    ...clocking,
                    clockOut:moment(date)
                  })
                }
                setAttendanceTime(date);
                setPunchTime(moment(date).format(FORMAT.HHMM_A));
              }}
            />
            {errorMsg&& <DKLabel text={errorMsg} className="text-red" />}
            {isInvalidAddClockout()&&<DKLabel className="text-red fs-s ml-xs" text="Clock-Out time should be greater than clock-In time"/>}
          </div>
        </div></>
        }{
          (props.data.isEdit && !props.data.isFromPunchlog) && <>
          <div className="row justify-content-between mt-s">
          <div className="d-flex">
            <DKLabel text="Clock-In*" className="" />
            {getTooltip(
              {
                tooltipText: "All punch log entries before the first clock-in would be cleared",
                tooltipClass: "warning-tooltip-prop",
              }
            )}
          </div>
          <div style={{ width: "54%" }}>
            <DKInputDateTime
              title={`Select Time`}
              hideCalendar={true}
              className="parent-width m-v-s "
              hideLabel={true}
              
              selectedDate={moment(clocking.clockIn, FORMAT.HHMM_A).format()}
              onSave={(date) => {
                setClockingAttendanceTime({
                  ...clockingAttendanceTime,
                  clockIn: date
                })
                setClocking({
                  ...clocking,
                  clockIn:moment(date)
                })
              }}
            />
          </div>
        </div>

        <div className="row justify-content-between">
        <div className="d-flex">
        <DKLabel text="Clock-Out*" className="" />
            {getTooltip(
              {
                tooltipText: "All punch log entries after the last clock-out would be cleared",
                tooltipClass: "warning-tooltip-prop",
              }
            )}
          </div>
          
          <div style={{ width: "54%" }}>
            <DKInputDateTime
              title={`Select Time`}
              hideCalendar={true}
              className={`parent-width m-v-s ${isInvalidClockout() ? "border-red border-radius-s":""}`}
              hideLabel={true}
              selectedDate={moment(clocking.clockOut, FORMAT.HHMM_A).format()}
              onSave={(date) => {
                setClockingAttendanceTime({
                  ...clockingAttendanceTime,
                  clockOut: date
                })
                setClocking({
                  ...clocking,
                  clockOut:moment(date)
                })
              }}
            />
            {isInvalidClockout()&&<DKLabel className="text-red fs-s ml-xs" text="Clock-Out time should be greater than clock-In time"/>}
          </div>
        </div>
          </>
        }
        <DKInput
          title={"Remark"}
          className="mt-r"
          value={remark}
          type={INPUT_TYPE.TEXT}
          canValidate={canValidate}
          tooltip={{
            content: "Remark should not exceed 250 characters",
            className: "warning-tooltip-prop",
          }}
          validator={(value)=>{
            if(Utility.isEmpty(value.trim()) || value.length >250) {
              return false;
            } else {
              return true
            }
          }}
          required={true}
          onChange={(rm) => {
            setCanValidate(true)
            setRemark(rm)
          }}
        />
          {(TenantService.get(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED) && props.data.isFromPunchlog) && attachmentField({
            columnCode: "attachments",
            name: "Attachment",
            type: 'file',
            required: false,
            uiVisible: true,
            tooltiptext: 'Please select and upload valid file.',
            isValid: true
          })}
      </div>
    </Popup>
    {(TenantService.get(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED) && attachmentPopup?.showPopup) && showUploadPopup()}
  </>
  );
};
export default EmployeeAttendancePopup;
